module.exports = __webpack_public_path__ + "img/more.e8b736c2.svg";